import template from './prems-discount-customer-selector.html.twig';

const { Component, Context } = Shopware;
const { EntityCollection, Criteria } = Shopware.Data;

Component.register('prems-discount-customer-selector', {
    template,
    inheritAttrs: false,

    inject: ['repositoryFactory'],

    props: {
        discountCategory: {
            type: Object,
            required: false,
            default: null
        },
    },
    computed: {
        customerRepository() {
            return this.repositoryFactory.create('customer');
        },
        customerIds: {
            get() {
                this.ensureValueExist();
                return Object.keys(this.discountCategory.discountCustomerIds).length > 0 ?  this.discountCategory.discountCustomerIds : null;
            },
            set(customerIds) {
                this.ensureValueExist();
                this.discountCategory.discountCustomerIds = customerIds;
            }
        },
        customerCriteria() {
            return new Criteria().addFilter(
                Criteria.multi(
                    'AND',
                    [
                        Criteria.equals('guest', 0),
                        Criteria.equals('active', 1),
                    ],
                ),
            );
        }
    },

    created() {
        this.createdComponent();
    },

    data() {
        return {
            customers: null
        };
    },

    methods: {
        createdComponent() {
            this.customers = new EntityCollection(
                this.customerRepository.route,
                this.customerRepository.entityName,
                Context.api
            );

            if (!this.customerIds) {
                return Promise.resolve();
            }

            const criteria = new Criteria();
            criteria.setIds(this.customerIds);

            return this.customerRepository.search(criteria, Context.api).then((customers) => {
                this.customers = customers;
            });
        },
        ensureValueExist() {
            if (typeof this.discountCategory.discountCustomerIds === 'undefined' || this.discountCategory.discountCustomerIds === null) {
                this.discountCategory.discountCustomerIds = {};
            }
        },
        setCustomerIds(customers) {
            this.customerIds = customers.getIds();
            this.customers = customers;
        }
    }
});